// pages/Dashboard.jsx
import AllBookReviews from "../../components/home/booksDetailsComponents.jsx/AllBookReviews";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <AllBookReviews />
    </HomeLayout>
  );
}


